





























































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwModal, SwModalFooter, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import  { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core/core.store';

const cssPrefix = 'tenant-transfer';

@Component({
  components: {
    SwTextfield,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwButton,
  },
})
export default class TenantTransfer extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  showTransfer : any;
  @Prop({ required : true })
  data: any;
  enteredOrgId : string = '';

  transferTenant() {
    if (!this.enteredOrgId) {
      const message: InfoState = { infoType: 'high', infoMsg: String(this.$t('products.orgIdReq'))  };
      this.$store.commit('displayMessage', message);
    } else {
      const req: any = {
        toOrgId: this.enteredOrgId,
        tenantId: this.data.prodId,
      };
      this.$store.commit('startLoading');
      MswApiService.createCustomer.transferTenant(req)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'MSWAPP:ITTEMAILSENTSUCCESS') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.close();
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
    }
  }
  close() {
    this.$emit('close-transfer');
  }
}
